<template>
  <div class="project__contents">
    <div class="yamada-text">
      <div class="yamada-text__contents">
        <p class="yamada-text__title">{{ selectProjectDataList.title }}</p>
        <p class="yamada-text__title-en font__roboto">{{ selectProjectDataList.title_en }}</p>
        <div class="yamada-text__text text__area__style__align__both__ends text__area__style__line__feed">{{ selectProjectDataList.yamada_text }}</div>
        <div class="yamada-text__items-tag" v-for="tag in tags" v-bind:key="tag.id"> 
          <router-link  class="yamada-text__link-tag" v-bind:to ="{ path:`/WORKS/${tag}`,params:{ tag:tag }}">
            {{ tag }}
          </router-link>
        </div>   
      </div>
    </div>
    <div class="contents_area_white">
      <div class="outline">
        <div class="text__area__style__line__feed text__area__style__align__both__ends outline_text">{{ selectProjectDataList.outline_text }}</div>
        <div v-if="isEmpty(outlineQuoteUrl)">
          <span style="border-bottom: solid 1.2px #969696;" v-show="isEmpty(outlineQuoteSource)">
            <img style="height:14px;" src="/assets/img/common/quote_border_gray.svg">
            <a class="outline__quote outline__quote-link" target="_blank" v-bind:href="outlineQuoteUrl">{{ outlineQuoteSource }}</a>
          </span>
        </div>
        <div v-else>
          <span v-show="isEmpty(outlineQuoteSource)"><img style="height:14px;" src="/assets/img/common/quote_border_gray.svg"></span>
          <span class="outline__quote">{{ outlineQuoteSource }}</span>
        </div>
      </div>
      <div class="place-info" v-for="datePlaceCredit in datePlaceCreditList" v-bind:key="datePlaceCredit.id">
        <p class="place-info__title quote__text__area__quote_source text__area__style__line__feed" style="margin-top:70px;margin-bottom:20px;" v-show="isEmpty(datePlaceCredit.title_sub)">{{ datePlaceCredit.title_sub }}</p>
        <p class="place-info__date quote__text__area__text font__roboto">{{ datePlaceCredit.date }}</p>
        <p class="place-info__place quote__text__area__quote_source">{{ datePlaceCredit.place }}</p>
        <p class="place-info__place-en quote__text__area__quote_source__en font__roboto" >{{ datePlaceCredit.place_en }}</p>
        <div class="credit" v-show="isEmpty(datePlaceCredit.credit)">
          <div class="credit__area text__area__style__line__feed">{{ datePlaceCredit.credit }}</div>
          <div class="credit__area-en font__roboto text__area__style__line__feed">{{ datePlaceCredit.credit_en }}</div>
        </div>  
      </div>    
      <div class="video" v-show="isEmpty(videoLink)" v-for="videoLink in videoLinkList" v-bind:key="videoLink.id">
        <div class="video__area">
          <iframe v-bind:src="videoLink" allowfullscreen></iframe>
        </div>
      </div>    
      <div class="quote">
        <div class="quote__text text__area__style__align__both__ends text__area__style__line__feed">{{ selectProjectDataList.quote_text }}</div>
        <div class="quote__text-quote">
          <div v-if="isEmpty(quoteTextUrl)">
            <span style="border-bottom: solid 1.2px #969696;" v-show="isEmpty(quoteTextSource)">
              <img style="height:14px;" src="/assets/img/common/quote_border_gray.svg">
              <a class="quote__text-link" target="_blank" v-bind:href="quoteTextUrl">{{ quoteTextSource }}</a>
            </span>
          </div>
          <div v-else>
          <span v-show="isEmpty(quoteTextSource)"><img style="height:14px;" src="/assets/img/common/quote_border_gray.svg"></span>
            <span>{{ quoteTextSource }}</span>
          </div>
        </div>
        <div class="relation-site" v-for="relationSite in relationSiteList" v-bind:key="relationSite.id">
          <a class="relation-site__link text__area__style__line__feed" target="_blank" v-bind:href="relationSite.relation_site_url">{{ relationSite.relation_site_source }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProjectContents",
  props: {
    // projectのjsonデータ
    selectProjectDataList: {}
  },
  data() {
    return {
      tags: [],
      outlineQuoteSource: this.selectProjectDataList.outline_quote_source,
      outlineQuoteUrl: this.selectProjectDataList.outline_link_url,
      quoteTextSource: this.selectProjectDataList.quote_text_source,
      quoteTextUrl: this.selectProjectDataList.quote_text_url,
      // 日時・場所
      datePlaceCreditList: {},
      // Youtubeリンクリスト
      videoLinkList: [],
      // 関連サイト情報リスト
      relationSiteList: {}

    }
  },
  created: function() {
    this.tags = this.selectProjectDataList.tags
    this.datePlaceCreditList = this.selectProjectDataList.date_place_credit
    this.videoLinkList = this.selectProjectDataList.video_source
    this.relationSiteList = this.selectProjectDataList.relation_site
  },
  methods: {
    // 要素の空チェック
    isEmpty: function(content) {
      if (!content){
        return false
      }
      return true
     }
  }
};
</script>
<style lang="scss" scoped>
.project__contents {
  padding-bottom: 80px;
}
// 山田さんテキスト
.yamada-text {
  padding: 50px 0 60px 0;
  background: #000000;
  &__contents {
    display: block;
    width: 87%;
    margin: 0 auto;
    color: #ffffff;
  }
  &__title {
    white-space: pre-wrap;
    font-size: 20px;
    letter-spacing: 1.5px;
    -moz-font-feature-settings: "palt";
    -webkit-font-feature-settings: "palt";
    font-feature-settings: "palt";
  }
  &__title-en {
    letter-spacing: 1px;
    font-weight: bold;
    line-height: 1.5em;
    font-size: 12px;
    letter-spacing: 1.5px;
    padding-top: 5px;    
  }
  &__text {
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 15px;
    line-height: 1.9em;
  }
  &__items-tag {
    display: inline-block;
    margin-right: 10px;
  }
  &__link-tag {
    color: #ffffff;
    text-decoration: none;
    border-bottom: solid 1px #ffffff;
    font-size: 13px;
    padding-bottom: 2px;
    letter-spacing: 1.5px;
    -moz-font-feature-settings: "palt";
    -webkit-font-feature-settings: "palt";
    font-feature-settings: "palt";
  }
}
// 白背景コンテンツ表示領域
.contents_area_white {
  width: 87%;
  margin: 0 auto;
}
// プロジェクト
.outline {
    display: block;
    padding: 70px 0 30px 0;
  &_text {
    font-size: 15px;
    line-height: 1.9em;
  }
  &__quote {
    display: inline;
    font-size: 14px;
    color: #969696;
    letter-spacing: 1.5px;
    line-height: 1.8em;
    -moz-font-feature-settings: "palt";
    -webkit-font-feature-settings: "palt";
    font-feature-settings: "palt";
  }
  &__quote-link {
    text-decoration: none;
  }
}
// 日時・場所
.place-info {
  display: block;
  line-height: 1.9em;
  padding-top: 20px;
  letter-spacing: 1.5px;
  -moz-font-feature-settings: "palt";
  -webkit-font-feature-settings: "palt";
  font-feature-settings: "palt";
  &__date {
    font-size: 15px;
  }
  &__place {
    font-size: 15px;
  }
  &__place-en {
    font-size: 14px;
    line-height: 1.3em;
  }
}
// クレジット
.credit {
  display: block;
  margin: 0 auto;
  &__area {
    line-height: 1.9em;
    margin-top: 50px;
    font-size: 15px;
  }
  &__area-en {
    margin-top: 50px;
    font-size: 14px;
    line-height: 1.8em;
  }
}
// Youtube
.video {
  padding-top: 60px;
  display: block;
  &__area {
    position: relative;
    height: 0;
    padding: 30px 0 56.25%;
    overflow: hidden;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
// 引用文
.quote {
  margin-top: 60px;
  &__text {
    display: block;
    font-size: 15px;
    line-height: 1.9em;
  }
  &__text-quote {
    font-size: 14px;
    line-height: 1.8em;
    margin-bottom: 50px;
    color: #969696;
    letter-spacing: 1.5px;
    -moz-font-feature-settings: "palt";
    -webkit-font-feature-settings: "palt";
    font-feature-settings: "palt";
  }
  &__text-link {
    color: #969696;
    text-decoration: none;
  }
}
// 関連サイト
.relation-site {
  font-size: 15px;
  margin-top: 10px;
  letter-spacing: 1.5px;
  line-height: 1.9em;
  -moz-font-feature-settings: "palt";
  -webkit-font-feature-settings: "palt";
  font-feature-settings: "palt";
  &__link {
    text-decoration: none;
    display: inline;
    color: #969696;
    border-bottom: solid 1.2px #969696;
  }
}
// PC
@media screen and (min-width: 768px) {
  // 山田さんテキスト
  .yamada-text {
    padding: 50px 0 60px 0;
    background: #000000;
    &__contents {
      width: 60%;
    }
    &__title {
      font-size: 23px;
      letter-spacing: 1.5px;
      -moz-font-feature-settings: "palt";
      -webkit-font-feature-settings: "palt";
      font-feature-settings: "palt";
    }
    &__title-en {
      letter-spacing: 1px;
      font-weight: bold;
      font-size: 14px;
      letter-spacing: 1.5px;
      padding-top: 5px;    
    }
    &__text {
      font-size: 16px;
      margin-top: 30px;
      margin-bottom: 30px;
      line-height: 2em;
    }
    &__items-tag {
      display: inline-block;
      margin-right: 10px;
    }
    &__link-tag {
      color: #ffffff;
      text-decoration: none;
      border-bottom: solid 1px #ffffff;
      font-size: 13px;
      padding-bottom: 2px;
      letter-spacing: 1.5px;
      -moz-font-feature-settings: "palt";
      -webkit-font-feature-settings: "palt";
      font-feature-settings: "palt";
    }
  }
  // 白背景コンテンツ表示領域
  .contents_area_white {
    width: 60%;
    margin: 0 auto;
  }
  // プロジェクト
  .outline {
    &_text {
      font-size: 16px;
      line-height: 2em;
    }
    &__quote {
      line-height: 2em;
    }
  }
  // 日時・場所
  .place-info {
    &__date {
      font-size: 16px;
    }
    &__place {
      font-size: 16px;
    }
    &__place-en {
      font-size: 15px;
      line-height: 2em;
    }
  }
  // クレジット
  .credit { 
    &__area {
      line-height: 2em;
      font-size: 16px;
    }
    &__area-en {
      line-height: 1.9em;
    }
  }
  // 引用文
  .quote {
    margin-top: 60px;
    &__text {
      font-size: 16px;
      line-height: 2em;
    }
    &__text-quote {
      font-size: 14px;
      line-height: 1.9em;
      margin-bottom: 50px;
    }
    &__text-link {
      color: #969696;
      text-decoration: none;
    }
  }
  // 関連サイト
  .relation-site {
    font-size: 16px;
    line-height: 2em;
  }
}
</style>